import React, { useState, useEffect, useCallback } from 'react';
import './DigitalTwin.css';

const DEMO_VIDEO_SRC = `${process.env.PUBLIC_URL}/assets/img/apps/oculo/videos/oculo-updated.mp4`;

function DigitalTwin() {
  const [lightboxOpen, setLightboxOpen] = useState(false);

  const openLightbox = () => setLightboxOpen(true);
  const closeLightbox = useCallback(() => setLightboxOpen(false), []);

  useEffect(() => {
    if (!lightboxOpen) return;
    const onKey = (e) => { if (e.key === 'Escape') closeLightbox(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [lightboxOpen, closeLightbox]);

  return (
    <section style={{ background: '#180C2E', padding: '104px 56px' }}>
      <div style={{ maxWidth: 1180, margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 56, alignItems: 'center', marginBottom: 48 }} className="oc-grid-2">
          <div className="oc-reveal">
            <span style={{ font: '700 12px Manrope,sans-serif', letterSpacing: '0.16em', color: '#816BFF' }}>THE DIGITAL TWIN</span>
            <h2 style={{ margin: '14px 0 0', fontFamily: 'Montserrat,sans-serif', fontWeight: 800, fontSize: 38, lineHeight: 1.12, letterSpacing: '-0.015em', color: '#fff' }}>
              Verify in the document you already know.
            </h2>
          </div>
          <div className="oc-reveal">
            <p style={{ margin: 0, fontFamily: 'Montserrat,sans-serif', fontSize: 18, lineHeight: 1.65, color: 'rgba(255,255,255,0.72)' }}>
              Oculo returns a document that looks exactly like the original, except every field is digital, editable, and linked to the structured record. If a value is wrong, correct it in place. No cross-referencing. No side panels.
            </p>
          </div>
        </div>

        {/* Screenshot with play button overlay */}
        <div className="oc-reveal oc-twin-wrapper" onClick={openLightbox} role="button" tabIndex={0} aria-label="Play Oculo demonstration" onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') openLightbox(); }}>
          <img
            src={`${process.env.PUBLIC_URL}/assets/img/apps/oculo/oculo-screenshot.png`}
            alt="Oculo digital twin — original report alongside digital extracted twin"
            className="oc-twin-screenshot"
          />
          <div className="oc-twin-overlay">
            <button className="oc-play-btn" aria-hidden="true" tabIndex={-1}>
              <i className="bx bx-play" style={{ fontSize: 50, color: '#fff', marginLeft: 5 }} />
            </button>
            <span className="oc-play-label">Play demonstration</span>
          </div>
        </div>

        <div className="oc-reveal" style={{ display: 'flex', gap: 28, marginTop: 22, flexWrap: 'wrap', justifyContent: 'center' }}>
          {['Original on the left, extracted twin on the right', 'Every field editable in place', 'Linked to the structured record'].map(txt => (
            <span key={txt} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, font: '600 13px Manrope,sans-serif', color: 'rgba(255,255,255,0.65)' }}>
              <i className="bx bx-check" style={{ color: '#02A783', fontSize: 17 }} /> {txt}
            </span>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightboxOpen && (
        <div className="oc-lightbox" onClick={closeLightbox} role="dialog" aria-modal="true" aria-label="Oculo demonstration video">
          <button className="oc-lightbox-close" onClick={closeLightbox} aria-label="Close video">
            <i className="bx bx-x" />
          </button>
          <div className="oc-lightbox-content" onClick={e => e.stopPropagation()}>
            <video
              src={DEMO_VIDEO_SRC}
              controls
              autoPlay
              playsInline
              className="oc-lightbox-video"
            />
          </div>
        </div>
      )}
    </section>
  );
}

export default DigitalTwin;
